// @flow

import React from 'react';
import { Icon } from '@ta/styleguide.icon';
import { ResponsiveImage } from '@ta/media.image';
import { inputLength } from '@ta/common.string';

export const getPhoto = (photo: any, classname: string, icon: string | null) => {
  const sources = photo?.photoSizes;
  const height = 140;
  const width = '100%';
  if (!sources) {
    return icon ? (
      <div className={classname} style={{ width, height }}>
        <Icon name={icon} />
      </div>
    ) : null;
  }

  return (
    <ResponsiveImage sources={sources} width={width} height={`${height}px`} borderRadius="4px" />
  );
};

/**
 * Returns a truncated version of a passed string if it goes over a certain character limit
 * @param textBody - the string to be truncated
 * @param maxChar - the maximum number of characters allowed
 */
export function truncateLinkInfo(textBody: string, maxChar: number) {
  if (inputLength(textBody) > maxChar) {
    const tempBody = textBody.substr(0, maxChar - 1).trim();
    return `${tempBody.substr(0, tempBody.lastIndexOf(' '))}...`;
  }
  return textBody;
}
